var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 6C62 4 60 2 58 2H6C4 2 2 4 2 6V44H62V6Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 44V48C2 50 4 52 6 52H58C60 52 62 50 62 48V44H2Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54C24 58 20 58 16 58H48C44 58 40 58 40 54V52H24V54Z",
    fill: "#E8E8ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H58V40H6V6Z",
    fill: "#87858C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.8999C32.5523 48.8999 33 48.4522 33 47.8999C33 47.3476 32.5523 46.8999 32 46.8999C31.4477 46.8999 31 47.3476 31 47.8999C31 48.4522 31.4477 48.8999 32 48.8999Z",
    fill: "#0280F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 58H48V62H16V58Z",
    fill: "#B2B2B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePc);
export default __webpack_public_path__ + "static/media/Image-pc.628639d584900ffe37a585d038f014ed.svg";
export { ForwardRef as ReactComponent };